import burjKhalifaIMG from "../imagens/burj-khalifa.jpg";
import torreEiffelIMG from "../imagens/torre-eiffel.jpg";
import monteEverestIMG from "../imagens/monte-everest.jpg";
import estacaoEspacialInternacionalIMG from "../imagens/estacao-espacial-internacional.jpg";
import terraAteLuaIMG from "../imagens/terra-ate-lua.jpg";
import diametroDaTerraIMG from "../imagens/diametro-da-terra.jpg";
import avenidaPaulistaIMG from "../imagens/avenida-paulista.jpg";
import rodoviaBr101IMG from "../imagens/rodovia-br-101.jpg";
import rodoviaPanAmericanaIMG from "../imagens/rodovia-pan-americana.jpg";
import saoPauloToquioIMG from "../imagens/sao-paulo-toquio.jpg";
import timeDeFutebolIMG from "../imagens/time-de-futebol.jpg";
import onibusIMG from "../imagens/onibus.jpg";
import salaDeCinemaIMG from "../imagens/sala-de-cinema.jpg";
import boeing747IMG from "../imagens/boeing-747.jpg";
import maiorNavioDeCruzeiroIMG from "../imagens/maior-navio-de-cruzeiro.jpg";
import relogioIMG from "../imagens/relogio.jpg";
import calendarioIMG from "../imagens/calendario.jpg";
import japaoIMG from "../imagens/japao.jpg";
import piscinaIMG from "../imagens/piscina.jpg";
import caminhaoTanqueIMG from "../imagens/caminhao-tanque.jpg";

export type CuriosityType =
	| "height"
	| "distance-side-by-side"
	| "distance-in-line"
	| "one-to-one";

const USE_LOCAL_IMAGES = true;

const imageMap: Record<string, string> = {
	"burj-khalifa": burjKhalifaIMG,
	"torre-eiffel": torreEiffelIMG,
	"monte-everest": monteEverestIMG,
	"estacao-espacial-internacional": estacaoEspacialInternacionalIMG,
	"terra-ate-lua": terraAteLuaIMG,
	"diametro-da-terra": diametroDaTerraIMG,
	"avenida-paulista": avenidaPaulistaIMG,
	"rodovia-br-101": rodoviaBr101IMG,
	"rodovia-pan-americana": rodoviaPanAmericanaIMG,
	"sao-paulo-toquio": saoPauloToquioIMG,
	"time-de-futebol": timeDeFutebolIMG,
	onibus: onibusIMG,
	"sala-de-cinema": salaDeCinemaIMG,
	"boeing-747": boeing747IMG,
	"maior-navio-de-cruzeiro": maiorNavioDeCruzeiroIMG,
	relogio: relogioIMG,
	calendario: calendarioIMG,
	japao: japaoIMG,
	piscina: piscinaIMG,
	caminhaoTanque: caminhaoTanqueIMG,
};

const getImagePath = (key: string, url: string): string => {
	return USE_LOCAL_IMAGES ? imageMap[key] || url : url;
};

export interface CuriosityComparison {
	id: string;
	type: CuriosityType;
	name: string;
	description: string;
	value: number; //meters
	color: string;
	image: string;
	allowedTypes: ("cashless" | "ficha")[];
	category: "people" | "products" | "beer" | "operationTime";
}

export const heightComparisons: CuriosityComparison[] = [
	{
		id: "burjKhalifa",
		type: "height",
		name: "Burj Khalifa",
		description: "Empilhando todo mundo, dá {{value}} vezes o Burj Khalifa! 🏗️",
		value: 828,
		color: "Purple",
		image: getImagePath("burj-khalifa", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "eiffelTower",
		type: "height",
		name: "Torre Eiffel",
		description: "Uma torre humana de {{value}} Torre Eiffel! Bonjour! 🗼",
		value: 330,
		color: "Teal",
		image: getImagePath("torre-eiffel", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "mountEverest",
		type: "height",
		name: "Monte Everest",
		description: "{{value}} vezes a altura do Monte Everest, juntando todo mundo!",
		value: 8849,
		color: "Orange",
		image: getImagePath("monte-everest", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "issOrbit",
		type: "height",
		name: "Estação Espacial Internacional",
		description:
			"Alcançamos {{value}} vezes a órbita da ISS somando a altura de todo mundo! 🚀",
		value: 408000,
		color: "Blue",
		image: getImagePath("estacao-espacial-internacional", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "earthToMoon",
		type: "height",
		name: "Terra até a Lua",
		description: "Uma escada humana equivalente a {{value}} viagens até a Lua! 🌙",
		value: 384400000,
		color: "Indigo",
		image: getImagePath("terra-ate-lua", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
];

export const distanceSideBySideComparisons: CuriosityComparison[] = [
	{
		id: "earthDiameter",
		type: "distance-side-by-side",
		name: "Diâmetro da Terra",
		description: "De mãos dadas, dá {{value}} vezes o diâmetro da Terra! 🌍",
		value: 12742000,
		color: "Green",
		image: getImagePath("diametro-da-terra", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
];

export const distanceInLineComparisons: CuriosityComparison[] = [
	{
		id: "avenidaPaulista",
		type: "distance-in-line",
		name: "Avenida Paulista",
		description:
			"Em fila, formamos {{value}} vezes a Avenida Paulista! Do MASP até a esquina... e muito além!",
		value: 2800,
		color: "Yellow",
		image: getImagePath("avenida-paulista", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "br101",
		type: "distance-in-line",
		name: "Rodovia BR-101",
		description:
			"Nossa fila cobriria {{value}} vezes a BR-101! De ponta a ponta do litoral brasileiro!",
		value: 4800000,
		color: "Rose",
		image: getImagePath("rodovia-br-101", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "panAmericana",
		type: "distance-in-line",
		name: "Rodovia Pan-americana",
		description:
			"Formando uma fila, atravessamos {{value}} vezes a Pan-americana! Do Alasca à Argentina!",
		value: 48000000,
		color: "Amber",
		image: getImagePath("rodovia-pan-americana", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "saoPauloToTokyo",
		type: "distance-in-line",
		name: "São Paulo → Tóquio",
		description:
			"Conectamos São Paulo e Tóquio {{value}} vezes em fila! Sayōnara, Brasil!",
		value: 19000000,
		color: "Pink",
		image: getImagePath("sao-paulo-toquio", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
];

export const oneToOneComparisons: CuriosityComparison[] = [
	{
		id: "soccerTeam",
		type: "one-to-one",
		name: "Time de Futebol",
		description: "Dá pra escalar {{value}} times de futebol completos! Bora pro hexa! ⚽",
		value: 11,
		color: "Green",
		image: getImagePath("time-de-futebol", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "bus",
		type: "one-to-one",
		name: "Ônibus",
		description: "{{value}} ônibus lotados! Igual horário de rush na segunda-feira! 🚌",
		value: 50,
		color: "Orange",
		image: getImagePath("onibus", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "cinema",
		type: "one-to-one",
		name: "Sala de Cinema",
		description: "Lotamos {{value}} salas de cinema! Pipoca para todo mundo! 🍿",
		value: 300,
		color: "Purple",
		image: getImagePath("sala-de-cinema", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "boeing747",
		type: "one-to-one",
		name: "Boeing 747",
		description:
			"Da pra lotar {{value}} vezes um Boeing 747! Preparados para a decolagem! ✈️",
		value: 450,
		color: "Blue",
		image: getImagePath("boeing-747", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "cruiseShip",
		type: "one-to-one",
		name: "Maior Navio de Cruzeiro",
		description:
			"Daria para lotar {{value}} navios Icon of the Seas! Cruzeiro coletivo rumo ao Caribe! 🚢",
		value: 10000,
		color: "Cyan",
		image: getImagePath("maior-navio-de-cruzeiro", ""),
		allowedTypes: ["cashless"],
		category: "people",
	},
	{
		id: "relogio",
		type: "one-to-one",
		name: "",
		description:
			"Uma média de {{value}} produtos vendidos para cada minuto de operação ⏰",
		value: 525960,
		color: "Slate",
		image: getImagePath("relogio", ""),
		allowedTypes: ["ficha", "cashless"],
		category: "products",
	},
	{
		id: "calendario",
		type: "one-to-one",
		name: "",
		description: "Uma média de {{value}} produtos vendidos por dia de operação 📅",
		value: 365,
		color: "Slate",
		image: getImagePath("calendario", ""),
		allowedTypes: ["ficha", "cashless"],
		category: "products",
	},
	{
		id: "japao",
		type: "one-to-one",
		name: "Do Brasil ao Japão",
		description:
			"Com todo tempo de operação, seria possível fazer {{value}} viagens para o Japão! ✈️",
		value: 26, // Horas de voo SP-Tóquio (média)
		color: "Cyan",
		image: getImagePath("japao", ""),
		allowedTypes: ["ficha", "cashless"],
		category: "operationTime",
	},
	{
		id: "piscina",
		type: "one-to-one",
		name: "Piscina Olimpica de Cerveja",
		description:
			"Com toda cerveja vendida, seria possível lotar {{value}} piscinas olimpicas! 🍺",
		value: 2500000,
		color: "Cyan",
		image: getImagePath("piscina", ""),
		allowedTypes: ["ficha", "cashless"],
		category: "beer",
	},
	{
		id: "caminhaoTanque",
		type: "one-to-one",
		name: "Caminhão Tanque de Cerveja",
		description:
			"Com toda cerveja vendida, seria possível lotar {{value}} caminhões tanque! 🚛",
		value: 10000,
		color: "Cyan",
		image: getImagePath("caminhaoTanque", ""),
		allowedTypes: ["ficha", "cashless"],
		category: "beer",
	},
];

export const allComparisons: CuriosityComparison[] = [
	...heightComparisons,
	...distanceSideBySideComparisons,
	...distanceInLineComparisons,
	...oneToOneComparisons,
];
